var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_707_3700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.96413 12.1236C9.88912 12.1236 12.2603 9.75241 12.2603 6.82741C12.2603 3.90242 9.88912 1.53125 6.96413 1.53125C4.03914 1.53125 1.66797 3.90242 1.66797 6.82741C1.66797 9.75241 4.03914 12.1236 6.96413 12.1236Z",
    stroke: "#6D6D6D",
    strokeWidth: 1.19164
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28871 5.50342L5.64062 8.1515M5.64062 5.50342L8.28871 8.1515",
    stroke: "#6D6D6D",
    strokeWidth: 1.19164,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_707_3700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.7108,
    height: 12.7108,
    fill: "white",
    transform: "translate(0.609375 0.471924)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleIcon);
export default __webpack_public_path__ + "static/media/closeCircleIcon.5b93732f8b3e41022b02d8a5d5a49d99.svg";
export { ForwardRef as ReactComponent };